module.exports = __webpack_public_path__ + "img/3.56cb9e3d.png";